//have api to be assigned walls
//when robots move around they check to see if collision occur, if they do then robots stop

export default class Tile {
  constructor(symbol, position){
    this.leftWall = false;
    this.downWall = false;
    this.upWall = false;
    this.rightWall = false;
    this.symbol = symbol;
    (symbol || position) && this.assignWall(symbol, position)
  }

  assignWall(direction, position) {
    if(Object.hasOwnProperty(direction+"Wall")) {
      this[direction+'Wall'] = true
    }
    if(/_/.test(direction) || /(bottom|middle)/.test(position)) {
      this.downWall = true
    }
    if(/-/.test(direction) || /(top|middle)/.test(position)) {
      this.upWall = true
    }
    if(direction.indexOf('l') === 0 || /(left|middle)/.test(position)) {
      this.leftWall = true
    }
    if(direction.indexOf('l') === 1 || /(right|middle)/.test(position)) {
      this.rightWall = true
    }
  }
};


// WEBPACK FOOTER //
// ./game/Tile.js